// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendorPurchaseOrder_documentsTableWrapper__MiasI {
  width: 100%;
}

.vendorPurchaseOrder_backButton__87xGm {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
}

.vendorPurchaseOrder_emptyState__Tlkqr {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #ffffff;
}

.vendorPurchaseOrder_emptyStateText__EOb8u {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}

.vendorPurchaseOrder_documentsTableContainer__IVX7n {
  width: 100%;
  max-height: calc(100vh - 120px);
  overflow: auto;
  border-radius: 12px !important;
  border-color: #d4d8e1 !important;
}

.vendorPurchaseOrder_documentsTable__HEBzy {
  width: 100%;
  min-width: 900px;
}

.vendorPurchaseOrder_documentsTableHeader__h6\\+9Y {
  background-color: #f9fafb !important;
}

.vendorPurchaseOrder_documentsTableHeaderCell__hrp7I {
  font-weight: 600 !important;
  background-color: #f9fafb !important;
  white-space: nowrap;
}

.vendorPurchaseOrder_documentsTableCell__voWJW {
  font-weight: 500 !important;
  color: #1f2937 !important;
}

.vendorPurchaseOrder_actionsCell__CXsaD {
  text-align: center;
  white-space: nowrap;
}

/* Campaign History Table */

.vendorPurchaseOrder_campaignTableWrapper__TwlcD {
  width: 100%;
  overflow-x: auto;
}

.vendorPurchaseOrder_campaignTable__gj5nf {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
}

.vendorPurchaseOrder_campaignTableHeader__EpTze {
  position: sticky;
  top: 0;
  z-index: 20;

  border-bottom: 1px solid #d4d8e1;
  background-color: #f8fafc;

  padding: 16px 24px;

  text-align: left;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.025em;

  color: #4b5563;
}

.vendorPurchaseOrder_campaignTableHeaderCenter__IcgzG {
  position: sticky;
  top: 0;
  z-index: 20;

  border-bottom: 1px solid #d4d8e1;
  background-color: #f8fafc;

  padding: 16px 24px;

  text-align: center;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.025em;

  color: #4b5563;
}

.vendorPurchaseOrder_campaignTableRow__QhIdY {
  border-bottom: 1px solid #e5e7eb;
}

.vendorPurchaseOrder_campaignTableRow__QhIdY:last-child {
  border-bottom: 0;
}

.vendorPurchaseOrder_campaignTableCell__eaY9Y {
  padding: 24px;
}

.vendorPurchaseOrder_campaignTableCellCenter__l1lnF {
  padding: 24px;
  text-align: center;
}

.vendorPurchaseOrder_campaignTableDate__\\+e\\+Jy {
  padding: 24px;
}

.vendorPurchaseOrder_campaignTableArea__GHZJs {
  padding: 24px;
}

.vendorPurchaseOrder_campaignTableValue__vder0 {
  padding: 24px;
}

.vendorPurchaseOrder_campaignTableEmpty__jd8EA {
  padding: 64px 24px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/vendorPurchaseOrder.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2BAA2B;;AAE3B;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;;EAEX,gCAAgC;EAChC,yBAAyB;;EAEzB,kBAAkB;;EAElB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;;EAEvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;;EAEX,gCAAgC;EAChC,yBAAyB;;EAEzB,kBAAkB;;EAElB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;;EAEvB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".documentsTableWrapper {\n  width: 100%;\n}\n\n.backButton {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  cursor: pointer;\n}\n\n.emptyState {\n  min-height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.emptyStateText {\n  margin: 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.documentsTableContainer {\n  width: 100%;\n  max-height: calc(100vh - 120px);\n  overflow: auto;\n  border-radius: 12px !important;\n  border-color: #d4d8e1 !important;\n}\n\n.documentsTable {\n  width: 100%;\n  min-width: 900px;\n}\n\n.documentsTableHeader {\n  background-color: #f9fafb !important;\n}\n\n.documentsTableHeaderCell {\n  font-weight: 600 !important;\n  background-color: #f9fafb !important;\n  white-space: nowrap;\n}\n\n.documentsTableCell {\n  font-weight: 500 !important;\n  color: #1f2937 !important;\n}\n\n.actionsCell {\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* Campaign History Table */\n\n.campaignTableWrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.campaignTable {\n  width: 100%;\n  min-width: 900px;\n  border-collapse: collapse;\n}\n\n.campaignTableHeader {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n\n  border-bottom: 1px solid #d4d8e1;\n  background-color: #f8fafc;\n\n  padding: 16px 24px;\n\n  text-align: left;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n\n  color: #4b5563;\n}\n\n.campaignTableHeaderCenter {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n\n  border-bottom: 1px solid #d4d8e1;\n  background-color: #f8fafc;\n\n  padding: 16px 24px;\n\n  text-align: center;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n\n  color: #4b5563;\n}\n\n.campaignTableRow {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.campaignTableRow:last-child {\n  border-bottom: 0;\n}\n\n.campaignTableCell {\n  padding: 24px;\n}\n\n.campaignTableCellCenter {\n  padding: 24px;\n  text-align: center;\n}\n\n.campaignTableDate {\n  padding: 24px;\n}\n\n.campaignTableArea {\n  padding: 24px;\n}\n\n.campaignTableValue {\n  padding: 24px;\n}\n\n.campaignTableEmpty {\n  padding: 64px 24px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"documentsTableWrapper": `vendorPurchaseOrder_documentsTableWrapper__MiasI`,
	"backButton": `vendorPurchaseOrder_backButton__87xGm`,
	"emptyState": `vendorPurchaseOrder_emptyState__Tlkqr`,
	"emptyStateText": `vendorPurchaseOrder_emptyStateText__EOb8u`,
	"documentsTableContainer": `vendorPurchaseOrder_documentsTableContainer__IVX7n`,
	"documentsTable": `vendorPurchaseOrder_documentsTable__HEBzy`,
	"documentsTableHeader": `vendorPurchaseOrder_documentsTableHeader__h6+9Y`,
	"documentsTableHeaderCell": `vendorPurchaseOrder_documentsTableHeaderCell__hrp7I`,
	"documentsTableCell": `vendorPurchaseOrder_documentsTableCell__voWJW`,
	"actionsCell": `vendorPurchaseOrder_actionsCell__CXsaD`,
	"campaignTableWrapper": `vendorPurchaseOrder_campaignTableWrapper__TwlcD`,
	"campaignTable": `vendorPurchaseOrder_campaignTable__gj5nf`,
	"campaignTableHeader": `vendorPurchaseOrder_campaignTableHeader__EpTze`,
	"campaignTableHeaderCenter": `vendorPurchaseOrder_campaignTableHeaderCenter__IcgzG`,
	"campaignTableRow": `vendorPurchaseOrder_campaignTableRow__QhIdY`,
	"campaignTableCell": `vendorPurchaseOrder_campaignTableCell__eaY9Y`,
	"campaignTableCellCenter": `vendorPurchaseOrder_campaignTableCellCenter__l1lnF`,
	"campaignTableDate": `vendorPurchaseOrder_campaignTableDate__+e+Jy`,
	"campaignTableArea": `vendorPurchaseOrder_campaignTableArea__GHZJs`,
	"campaignTableValue": `vendorPurchaseOrder_campaignTableValue__vder0`,
	"campaignTableEmpty": `vendorPurchaseOrder_campaignTableEmpty__jd8EA`
};
export default ___CSS_LOADER_EXPORT___;
